module.exports = __webpack_public_path__ + "img/195.6545dd52.jpg";